import React, { Fragment, useState, useEffect } from "react";
import { IconCalendar, IconChevronDown } from "@tabler/icons-react";
import { CommonUtils, DatetimeUtils } from "utils";
import "chart.js/auto";
import { Bar } from "react-chartjs-2";
import { useStatisticMessageGet } from "hooks";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";
import SelectDateTime from "./SelectDateTime";

const MessageStatistic = ({ unitList }) => {
  const { t: getLabel } = useTranslation();
  const { getStatisticMessage } = useStatisticMessageGet();

  const [unitId, setUnitId] = useState("0");
  const [labelCalendar, setLabelCalendar] = useState(getLabel(LangConstant.TXT_DATE_TODAY));
  const [totalMessage, setTotalMessage] = useState(0);
  const [dataSet, setDataSet] = useState("");
  const [sinceTime, setSinceTime] = useState(CommonUtils.getStartToday());
  const [lastTime, setLastTime] = useState(null);

  const [openDateTime, setOpenDateTime] = useState(false);

  const onChangeUnit = e => {
    setUnitId(String(e.target.value));
  };

  useEffect(() => {
    const fetchData = async () => {
      const payload = {};
      if (String(unitId) === "0") {
        payload.include_unit_id = 0;
      } else {
        payload.include_unit_id = 1;
      }
      if (String(unitId) !== "0" && String(unitId) !== "-1") {
        payload.unit_id = unitId;
      }
      if (sinceTime) {
        payload.since_time = sinceTime;
      }
      if (lastTime) {
        payload.last_time = lastTime;
      }

      const response = await getStatisticMessage(payload);
      if (response) {
        const responseData = response.data.sort((a, b) => {
          const dateA = new Date(a.date.split("/").reverse().join("-"));
          const dateB = new Date(b.date.split("/").reverse().join("-"));
          return dateA - dateB;
        });
        const label = responseData.map(item => item.date);
        const data = responseData.map(item => item.message_send);
        setTotalMessage(data.reduce((sum, element) => sum + element, 0));

        setDataSet({
          labels: label,
          datasets: [
            {
              label: getLabel(LangConstant.TXT_STATISTIC_NUM_MESSAGES),
              data: data,
              backgroundColor: ["#357AF6"],
            },
          ],
        });
      }
    };

    fetchData();
  }, [unitId, sinceTime, lastTime]);

  return (
    <Fragment>
      <div className="d-flex justify-content-between align-items-center pb-2 mb-2 border-bottom">
        <h3 className="m-0">{getLabel(LangConstant.TXT_STATISTIC_MESSAGE_OVERVIEW)}</h3>
        <div className="d-flex gap-3 position-relative">
          <select
            className="form-select"
            style={{ width: "200px" }}
            onChange={onChangeUnit}
            value={unitId}
          >
            {unitList.map(data => (
              <option key={data.unitId} value={data.unitId}>
                {data.unitName}
              </option>
            ))}
          </select>

          <div
            className="btn btn-outline-secondary d-flex align-items-center gap-2"
            style={{ minWidth: "200px", maxWidth: "250px" }}
            onClick={() => setOpenDateTime(!openDateTime)}
          >
            <IconCalendar size={18} />
            <span className="flex-grow-1">{labelCalendar}</span>
            <IconChevronDown size={16} />
          </div>

          <div style={{ position: "absolute", zIndex: 4, top: "42px", right: "0px" }}>
            <SelectDateTime
              open={openDateTime}
              setLabel={setLabelCalendar}
              onClose={() => setOpenDateTime(false)}
              setSinceTime={setSinceTime}
              setLastTime={setLastTime}
            />
          </div>
        </div>
      </div>

      <div className="d-flex flex-column justify-content-around" style={{ height: "550px" }}>
        <div className="card" style={{ height: "90%", width: "90%" }}>
          <div className="card-body">
            <h4 className="card-title d-flex align-items-center">
              {getLabel(LangConstant.TXT_STATISTIC_TOTAL_MESSAGES_SENT)}
              <span className="ms-2 fs-3 fw-bold text-primary">{totalMessage} {getLabel(LangConstant.TXT_STATISTIC_MESSAGES_UNIT)}</span>
            </h4>
            <div className="d-flex flex-column align-items-center w-100" style={{ height: "90%" }}>
              {Boolean(dataSet) && <Bar data={dataSet} options={{ skipNull: true }} />}
            </div>
          </div>
        </div>
      </div>

      <p className="text-secondary small">
        {getLabel(LangConstant.TXT_STATISTIC_DATA_UPDATED_AT, { time: DatetimeUtils.convertMillisecondsToDateTime(Date.now()) })}
      </p>
    </Fragment>
  );
};

export default MessageStatistic;
